import { baseUrl, buildQuery } from "../config/api-config";
import { Category } from "@mui/icons-material";
import axios from "axios";

export function getAllVendor(token, query) {
  const qs = buildQuery(query);
  return axios.get(`${baseUrl}/getAllVendors${qs}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getAllInventory(token, query) {
  const qs = buildQuery(query);
  return axios.get(`${baseUrl}/getAllInventory${qs}`, {
    headers: {
      authorization: token,
    },
  });
}
export function AddNewInventory(token, data) {
  return axios.post(`${baseUrl}/insertNewInventory`, data, {
    headers: {
      authorization: token,
    },
  });
}
export function getAllCategory(token, query) {
  const qs = buildQuery(query);
  return axios.get(`${baseUrl}/categories${qs}`, {
    headers: {
      authorization: token,
    },
  });
}
export function getInventory_By_ID(token, id) {
  return axios.get(`${baseUrl}/getInventoryById/${id}`, {
    headers: {
      authorization: token,
    },
  });
}
export function getInventory_Job_By_ID(token, id,query) {
  const qs = buildQuery(query);
  return axios.get(`${baseUrl}/getJobsByInventory/${id}${qs}`, {
    headers: {
      authorization: token,
    },
  });
}
export function deleteInventoryBYid(token, id) {
  return axios.delete(`${baseUrl}/deleteInventoryById/${id}`, {
    headers: {
      authorization: token,
    },
  });
}
export function deleteInventoryPicBYid(token, id) {
  return axios.patch(`${baseUrl}/deleteInventorypic/${id}`, {
    headers: {
      authorization: token,
    },
  });
}

export function defaultpartUpdatebyid(token, data, id) {
  return axios.patch(`${baseUrl}/defaultpartUpdatebyid/${id}`, data, {
    headers: {
      authorization: token,
    },
  });
}
export function updateInventoryByID(token, id) {
  return axios.patch(`${baseUrl}/updateInventoryById/${id}`, {
    headers: {
      authorization: token,
    },
  });
}
